import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="10"
    height="8"
    viewBox="0 0 10 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0001 3.99972C9.99684 3.64898 9.85552 3.31365 9.60675 3.06638L6.74675 0.199721C6.62184 0.075554 6.45287 0.00585938 6.27675 0.00585938C6.10062 0.00585938 5.93166 0.075554 5.80675 0.199721C5.74426 0.261696 5.69467 0.33543 5.66082 0.41667C5.62698 0.497909 5.60955 0.585046 5.60955 0.673054C5.60955 0.761062 5.62698 0.848198 5.66082 0.929438C5.69467 1.01068 5.74426 1.08441 5.80675 1.14639L8.00008 3.33305H1.33341C1.1566 3.33305 0.987035 3.40329 0.86201 3.52831C0.736986 3.65334 0.666748 3.82291 0.666748 3.99972C0.666748 4.17653 0.736986 4.3461 0.86201 4.47112C0.987035 4.59614 1.1566 4.66638 1.33341 4.66638H8.00008L5.80675 6.85971C5.68121 6.98437 5.61034 7.15378 5.60971 7.33069C5.60909 7.5076 5.67876 7.67751 5.80341 7.80305C5.92807 7.92858 6.09748 7.99946 6.27439 8.00008C6.4513 8.00071 6.62121 7.93103 6.74675 7.80638L9.60675 4.93972C9.85714 4.69082 9.99859 4.35277 10.0001 3.99972Z"
      fill="#151718"
    />
  </svg>
);

const ArrowRightIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default ArrowRightIcon;
